document.addEventListener('DOMContentLoaded', function () {
  // Wait for Swiper to be loaded
  if (typeof Swiper === 'undefined') {
    console.warn('Swiper not loaded, testimonial slider will not function');
    return;
  }

  const testimonialSliders = document.querySelectorAll('.testimonial__slider.swiper');
  
  testimonialSliders.forEach(slider => {
    let swiper = null;
    
    function initSwiper() {
      if (window.innerWidth < 990 && !swiper) {
        try {
          swiper = new Swiper(slider, {
            slidesPerView: 'auto',
            spaceBetween: 36,
            centeredSlides: true,
            freeMode: false,
            pagination: {
              el: '.testimonial-dots',
              clickable: true,
              renderBullet: function (index, className) {
                return '<span class="' + className + ' slider-dot"></span>';
              },
            },
          });
        } catch (error) {
          console.error('Error initializing Swiper:', error);
        }
      }
    }
    
    function destroySwiper() {
      if (swiper && window.innerWidth > 990) {
        try {
          swiper.destroy(true, true);
          swiper = null;
        } catch (error) {
          console.error('Error destroying Swiper:', error);
        }
      }
    }
    
    function handleResize() {
      if (window.innerWidth <= 990) {
        initSwiper();
      } else {
        destroySwiper();
      }
    }
    
    // Initialize on load
    handleResize();
    
    // Handle window resize with debounce
    let resizeTimeout;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(handleResize, 250);
    });
  });
});